import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportCsvInvoice } from './Invoice.service';

export function useInvoiceCsv() {
  return useMutation(getQuestReportCsvInvoice, {
    onSuccess() {
      notification.success({
        message:
          'O relatório Commissão por Movimentação foi gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
